// Moved exports to keep the imports working in other files: uiReducer, progress steps, trading history spec, and check eligibility.
import _ from 'lodash';

import { getCountryCode } from '@lendingAPI/lendingAPISelector';
import { isNewOffersEnabled } from '@src/containers/Offers/offers/offersHelpers';
import { isIwocaDE } from '@src/utils/countryHelper';

export const STEP_ZERO_STEP_ID = 'stepZero';
export const BUSINESS_INTRODUCTION_STEP_ID = 'businessIntroduction';
export const PERSONAL_INFORMATION_STEP_ID = 'personalInformation';
export const PRODUCT_OFFERS_STEP_ID = 'productOffers';
export const BUSINESS_ACCOUNTS_STEP_ID = 'businessAccounts';
export const CHECK_ELIGIBILITY_STEP_ID = 'checkEligibility';
export const MY_ACCOUNTS_STEP_ID = 'myAccount';

export const ALL_STEPS = [
    {
        id: STEP_ZERO_STEP_ID,
        name: 'Apply now',
        key: '0'
    },
    {
        id: BUSINESS_INTRODUCTION_STEP_ID,
        name: 'Introduce your business',
        key: '1'
    },
    {
        id: PERSONAL_INFORMATION_STEP_ID,
        name: 'Tell us about yourself',
        key: '2'
    },
    {
        id: 'productOffers',
        isConditional: true,
        condition: (state: any) => isNewOffersEnabled(state)
    },
    {
        id: CHECK_ELIGIBILITY_STEP_ID,
        name: 'Check eligibility',
        condition: (state: any) => getCountryCode(state) === 'uk'
    },
    {
        id: BUSINESS_ACCOUNTS_STEP_ID,
        name: 'Verify your trading history',
        key: '4'
    },
    {
        id: MY_ACCOUNTS_STEP_ID,
        name: 'My Account',
        key: '5'
    }
];

export const STEPS = ALL_STEPS.filter((step) => {
    if (isIwocaDE() && step.id === STEP_ZERO_STEP_ID) {
        return false;
    }
    return !_.get(step, 'isConditional', false);
});

/**
 *
 * @param {string} pathname
 * @returns {string}
 */
export const convertStepPathNameToActiveStepId = (pathname: string) => {
    switch (pathname) {
        case 'apply-now':
            return STEP_ZERO_STEP_ID;
        case 'business':
        case 'schritt-1':
            return BUSINESS_INTRODUCTION_STEP_ID;
        case 'applicant':
        case 'schritt-2':
            return PERSONAL_INFORMATION_STEP_ID;
        case 'documents':
        case 'schritt-3':
            return BUSINESS_ACCOUNTS_STEP_ID;
        default:
            return pathname;
    }
};

/**
 *
 * @param {string} pathname
 * @returns {string}
 */
export const convertActiveStepIdToStepPathName = (
    id: string,
    isUK?: boolean
) => {
    switch (id) {
        case STEP_ZERO_STEP_ID:
            return isUK ? 'apply-now' : 'schritt-1';
        case BUSINESS_INTRODUCTION_STEP_ID:
            return isUK ? 'business' : 'schritt-1';
        case PERSONAL_INFORMATION_STEP_ID:
            return isUK ? 'applicant' : 'schritt-2';
        case BUSINESS_ACCOUNTS_STEP_ID:
            return isUK ? 'documents' : 'schritt-3';
        default:
            return id;
    }
};

export const DEFAULT_STEP_ORDER = [
    STEP_ZERO_STEP_ID,
    BUSINESS_INTRODUCTION_STEP_ID,
    CHECK_ELIGIBILITY_STEP_ID,
    PERSONAL_INFORMATION_STEP_ID,
    PRODUCT_OFFERS_STEP_ID,
    BUSINESS_ACCOUNTS_STEP_ID
];
